import { FC } from 'react';
import { AlertsAndTasksView } from '../views/alerts-tasks/alerts-tasks';
import { BillingView } from '../views/billing/billing';
import { CommPreferencesView } from '../views/comm-preferences/comm-preferences';
import { AppointmentRemindersView } from '../views/comm-preferences/views/appointment-reminders/appointment-reminders';
import { DirectMailPreferencesView } from '../views/comm-preferences/views/direct-mail/direct-mail-preferences';
import { EmailPreferencesView } from '../views/comm-preferences/views/email/email-preferences';
import { PhoneCallPreferencesView } from '../views/comm-preferences/views/phone-call/phone-call-preferences';
import { TextMessagePreferencesView } from '../views/comm-preferences/views/text-messages/text-message-preferences';
import { FilesView } from '../views/files/files';
import { FormsView } from '../views/forms/forms';
import { GeneralView } from '../views/general/general-info';
import { InboxView } from '../views/inbox/inbox';
import { InboxFiltersView } from '../views/inbox/inbox-filters';
import { MainView } from '../views/main/main';
import { NotesView } from '../views/notes/notes';
import { PatientFeedbackView } from '../views/patient-feedback/patient-feedback';
import { ProfileSelectorView } from '../views/profile-selector/profile-selector';
import { ScheduledCommsView } from '../views/scheduled-comms/scheduled-comms';
import { TreatmentPlanView } from '../views/treatment-plans/treatment-plan';
import { VisitsView } from '../views/visits/visits';
import {PatientConnect365View} from "../views/patient-connect-365/patient-connect-365";

export enum WidgetRoutePath {
    MAIN = '/',
    GENERAL = '/general',
    SCHEDULED_COMMS = '/scheduled-comms',
    INBOX = '/inbox',
    INBOX_FILTERS = '/inbox/filters',
    COMM_PREFERENCES = '/comm-preferences',
    COMM_PREFERENCES_REMINDERS = '/comm-preferences/reminders',
    COMM_PREFERENCES_EMAIL = '/comm-preferences/email',
    COMM_PREFERENCES_TEXT_MESSAGE = '/comm-preferences/text-messages',
    COMM_PREFERENCES_DIRECT_MAIL = '/comm-preferences/direct-mail',
    COMM_PREFERENCES_PHONE_CALL = '/comm-preferences/phone-call',
    VISITS = '/visits',
    BILLING = '/billing',
    ALERTS_TASKS = '/alerts-tasks',
    PROFILE_SELECTOR = '/profile-selector',
    NOTES = '/notes',
    FILES = '/files',
    TREATMENT_PLANS = '/treatment-plans',
    PATIENT_FEEDBACK = '/patient-feedback',
    FORMS = '/forms',
    PATIENT_CONNECT_365 = '/patient-connect-365',
}

export type RouteConfigItem = { path: WidgetRoutePath; name: string; component: FC };

export const RouteConfig: RouteConfigItem[] = [
    { path: WidgetRoutePath.MAIN, component: MainView, name: 'Profile' },
    { path: WidgetRoutePath.GENERAL, component: GeneralView, name: 'General' },
    { path: WidgetRoutePath.SCHEDULED_COMMS, component: ScheduledCommsView, name: 'Scheduled Comms' },
    { path: WidgetRoutePath.INBOX, component: InboxView, name: 'Inbox' },
    { path: WidgetRoutePath.INBOX_FILTERS, component: InboxFiltersView, name: 'Inbox Filters' },
    { path: WidgetRoutePath.COMM_PREFERENCES, component: CommPreferencesView, name: 'Comm Preferences' },
    { path: WidgetRoutePath.FORMS, component: FormsView, name: 'Forms' },
    {
        path: WidgetRoutePath.COMM_PREFERENCES_REMINDERS,
        component: AppointmentRemindersView,
        name: 'Appointment Reminders'
    },
    { path: WidgetRoutePath.COMM_PREFERENCES_EMAIL, component: EmailPreferencesView, name: 'Email' },
    {
        path: WidgetRoutePath.COMM_PREFERENCES_TEXT_MESSAGE,
        component: TextMessagePreferencesView,
        name: 'Text Message'
    },
    { path: WidgetRoutePath.COMM_PREFERENCES_DIRECT_MAIL, component: DirectMailPreferencesView, name: 'Direct Mail' },
    { path: WidgetRoutePath.COMM_PREFERENCES_PHONE_CALL, component: PhoneCallPreferencesView, name: 'Phone Calls' },
    { path: WidgetRoutePath.VISITS, component: VisitsView, name: 'Visits' },
    { path: WidgetRoutePath.BILLING, component: BillingView, name: 'Billing' },
    { path: WidgetRoutePath.ALERTS_TASKS, component: AlertsAndTasksView, name: 'Alerts & Tasks' },
    { path: WidgetRoutePath.FILES, component: FilesView, name: 'Patient Files' },
    { path: WidgetRoutePath.NOTES, component: NotesView, name: 'Patient Notes' },
    { path: WidgetRoutePath.TREATMENT_PLANS, component: TreatmentPlanView, name: 'Treatment Plans' },
    { path: WidgetRoutePath.PATIENT_FEEDBACK, component: PatientFeedbackView, name: 'Patient Feedback' },
    { path: WidgetRoutePath.PROFILE_SELECTOR, component: ProfileSelectorView, name: 'Select Profile' },
    { path: WidgetRoutePath.PATIENT_CONNECT_365, component: PatientConnect365View, name: 'Patient Connect 365' },
];
